import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import React, { Fragment, useCallback } from 'react';
import { Row } from 'components/Grid';
import { usePageContext } from 'containers/Page/Context';
import { DiscoverMetaFragment } from '../../schema/apolloFragment/discoverFragment';

const types = [
  {
    label: 'All event types',
    value: null,
  },
  {
    label: 'Events open for application',
    value: 'applicable',
  },
  {
    label: 'Events partying now',
    value: 'partying',
  },
  {
    label: 'Events in the past',
    value: 'past',
  },
];

const DiscoverMeta = ({
  category,
  onCategoryChange,
  onTypeChange,
  type,
  value,
}) => {
  const { closeRightDrawer, rightDrawerOpen } = usePageContext();
  const handleTypeChange = useCallback(
    (e, i, v) => {
      if (rightDrawerOpen) {
        closeRightDrawer();
      }
      onTypeChange(e, i, v);
    },
    [closeRightDrawer, onTypeChange, rightDrawerOpen],
  );

  const renderCategoryMenuItem = useCallback(
    ({ name, slug }) => (
      <MenuItem
        key={slug}
        style={{ textTransform: 'capitalize' }}
        value={slug}
        disableTouchRipple
        disableFocusRipple
      >
        {name}
      </MenuItem>
    ),
    [],
  );
  const renderTypeMenuItem = useCallback(
    ({ label, values }) => (
      <MenuItem
        key={values || null}
        value={values}
        disableTouchRipple
        disableFocusRipple
      >
        {label}
      </MenuItem>
    ),
    [],
  );
  return (
    <Fragment>
      <Row inner>
        <h5>Filter</h5>
      </Row>
      <Row inner>
        <Select
          fullWidth
          variant='standard'
          displayEmpty
          onChange={useCallback(
            (e, i) => {
              if (rightDrawerOpen) {
                closeRightDrawer();
              }
              onCategoryChange(e, i, e.target.value);
            },
            [closeRightDrawer, onCategoryChange, rightDrawerOpen],
          )}
          value={value}
        >
          <MenuItem value='all' disableTouchRipple disableFocusRipple>
            All Categories
          </MenuItem>
          {category?.map(renderCategoryMenuItem)}
        </Select>
      </Row>
      {onTypeChange && (
        <Row inner>
          <Select fullWidth onChange={handleTypeChange} value={type}>
            {types.map(renderTypeMenuItem)}
          </Select>
        </Row>
      )}
    </Fragment>
  );
};

DiscoverMeta.propTypes = {
  category: PropTypes.string,
  onCategoryChange: PropTypes.func.isRequired,
  onTypeChange: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
};

export default DiscoverMeta;

DiscoverMeta.fragments = {
  category: DiscoverMetaFragment,
};
